/**
 * Commissie van de organisator over de kraamomzet.
 *
 * Regel 10: statiegeld hoort niet in de grondslag. Retouren en correcties
 * gaan er wel af — anders betaalt de kraam commissie over omzet die is
 * teruggedraaid.
 */

import { percentageVan, sommeer, type Basispunten, type Cent } from './geld.js';

export interface CommissieGrondslagInvoer {
  /** Alles wat de klant betaalde voor producten, inclusief BTW. */
  brutoOmzetCent: Cent;
  /** Statiegeld dat in dat brutobedrag zat. Wordt eruit gehaald. */
  statiegeldCent?: Cent;
  /** Terugbetaalde bedragen, als positief getal. */
  retourenCent?: Cent;
  /** Correcties op afgeronde bonnen: positief = bijbetaald, negatief = terug. */
  correctiesCent?: Cent;
}

export interface CommissieResultaat {
  grondslagCent: Cent;
  basispunten: Basispunten;
  commissieCent: Cent;
}

/** De omzet waarover commissie wordt gerekend. Nooit negatief. */
export function berekenCommissiegrondslag(invoer: CommissieGrondslagInvoer): Cent {
  const grondslag = sommeer([
    invoer.brutoOmzetCent,
    -(invoer.statiegeldCent ?? 0),
    -(invoer.retourenCent ?? 0),
    invoer.correctiesCent ?? 0,
  ]);
  return Math.max(0, grondslag);
}

export function berekenCommissie(
  invoer: CommissieGrondslagInvoer,
  basispunten: Basispunten,
): CommissieResultaat {
  if (!Number.isSafeInteger(basispunten) || basispunten < 0 || basispunten > 10_000) {
    throw new Error(
      `commissiepercentage moet tussen 0 en 10000 basispunten liggen: ${basispunten}`,
    );
  }
  const grondslagCent = berekenCommissiegrondslag(invoer);
  return {
    grondslagCent,
    basispunten,
    commissieCent: percentageVan(grondslagCent, basispunten),
  };
}
